export function getLastCharAndFirstPart(title) {
  if (!title) {
    return {}
  }
  return {
    firstPart: title.substr(0, title.length - 1),
    lastChar: title[title.length - 1],
  }
}
